<table id="addOnsList" class="condensed form-group">
    <thead class="fixed-header">
        <tr class="shift-block-head">
            <th class="census"></th>
            <ng-container *ngFor="let shiftBlock of shiftBlocks">
                <th>{{ shiftBlock.description }}</th>
            </ng-container>
        </tr>
    </thead>
    <tbody class="scrolling-body">
        <tr *ngFor="let row of addOnsStaffingGrid">
            <td>Net Add Ons %</td>
            <ng-container *ngFor="let cell of row; let i = index">
                <td>
                    <smt-staffing-grid-value [(gridCell)]="row[i]" (keyPressed)="cellKeyPressed($event)" (focusOut)="onFocusOut($event)"
                    [maxValue]="100"  [minValue]="-100" [isAddOn]="isAddOn"
                    [required]="true" [readOnly]="readOnly" [allowedDecimalPlaces]="2"></smt-staffing-grid-value>
                </td>
            </ng-container>
        </tr>
    </tbody>
</table>
